module.exports = __webpack_public_path__ + "media/images/patent/y_8-8ccd0343042a98360043becaf5f4a360.jpg";